import { useCallback } from "react";

import { useDuplicateReportColumn } from "@/queries";
import { ReportColumn } from "@/types/evaluate";
import { displayErrorToast } from "@/utils/toast";
import { useAuth } from "@/context/auth-context";

interface UseColumnDuplicationProps {
  reportId: number;
}

export const useColumnDuplication = ({ reportId }: UseColumnDuplicationProps) => {
  const userToken = useAuth()?.userToken || "";
  const { mutateAsync: duplicateColumn } = useDuplicateReportColumn(userToken, reportId);

  const handleDuplicateColumn = useCallback(
    async (column: ReportColumn) => {
      if (column.id && column.position !== undefined) {
        try {
          const response = await duplicateColumn(column.id);
          if (!response.success) {
            displayErrorToast(response.message || "There was an error duplicating the column");
          }
        } catch {
          displayErrorToast("There was an error duplicating the column");
        }
      }
    },
    [duplicateColumn],
  );

  return { handleDuplicateColumn };
};
